<template>

  <div v-if="componentType === 'ArtGalleryLoopPart1Image' && usageType === 'profilePage'" class="row align-items-center justify-content-center m-1" data-aos="zoom-in">

      <component :is="componentType"
        v-for="image in sortedelements"
        :key="image.url"
        :image="image"
        :usageType="'profilePage'"
  />
  </div>
  <div v-if="componentType === 'ArtGalleryLoopPart1Image' && usageType === 'galleryPage'" class="row align-items-center justify-content-center no-gutters" data-aos="zoom-in">

      <component :is="componentType"
        v-for="image in sortedelements"
        :key="image.url"
        :image="image"
        :usageType="'galleryPage'"
  />
  </div>
  <div v-if="componentType === 'ArtGalleryLoopPart1Image' && usageType === 'featurePage'" class="row gx-0" data-aos="zoom-in">

      <component :is="componentType"
        v-for="image in featurePageElements"
        :key="image.url"
        :image="image"
        :usageType="'featurePage'"
  />
  </div>
</template>

<script>
import ArtGalleryLoopPart1Image from '@/ArtGalleryLoopPart1Image.vue';


export default {
  components: {
    ArtGalleryLoopPart1Image,

  },
  props: ['year', 'componentType','userId', 'userSettings', 'artPosts', 'usageType'],
  data() {
    return {
      showStates: {},
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 768; // Bootstrap md breakpoint
    },
    featurePageElements() {
      return this.isMobile ? this.sortedelements.slice(0, 2) : this.sortedelements;
    },
    filteredImages() {
      // No year specified means the parent has already curated the list (e.g. top N across all years).
      if (this.year === null || this.year === undefined) {
        return this.artPosts;
      }
      let filtered = this.artPosts.filter(image => parseInt(image.year) === parseInt(this.year));
      console.log('Filtered artPosts:', filtered);
      return filtered;
    },
    sortedelements() {
      return [...this.filteredImages].sort((a, b) => parseInt(b.year) - parseInt(a.year) || a.ranking - b.ranking);
    },
    fetchStates() {
      let key = 'fetch' +this.year;
      return { [key]: this.filteredImages };
    },
    formattedYear() {
        return this.year === '2016' ? 'Archive' : this.year;
    },
  },
  created() {
    this.showStates['show' + this.year] = false;
  },
  mounted() {
    window.addEventListener('resize', this.updateWindowWidth);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
  methods: {
    toggle(key) {
      console.log('Toggling', key);
      this.showStates[key] = !this.showStates[key];
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>